import BugsnagPerformance from '@bugsnag/browser-performance'
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import {SafeArea} from "@capacitor-community/safe-area";
import {Capacitor} from "@capacitor/core";
import Clarity from "@microsoft/clarity";
import {createRouter, RouterProvider} from '@tanstack/react-router'
import {initializeApp} from "firebase/app";
import L from 'leaflet';

import 'react-swipeable-list/dist/styles.css';
import 'leaflet/dist/leaflet.css';
import '@capacitor-community/safe-area';

import './style_init.css';
import './style.scss';
import icon2x from 'leaflet/dist/images/marker-icon-2x.png?url';
import icon from 'leaflet/dist/images/marker-icon.png?url';
import iconShadow from 'leaflet/dist/images/marker-shadow.png?url';
import React, {StrictMode} from "react";
import ReactDOM from 'react-dom/client'
import {config} from "./config/config.ts";

import {routeTree} from './routeTree.gen'

declare module '@tanstack/react-router' {
    interface StaticDataRouteOption {
        backUrl?: string
    }
}

if (config.bugsnagApiKey) {
    Bugsnag.start({
        apiKey:       config.bugsnagApiKey,
        releaseStage: config.bugsnagReleaseStage,
        appVersion:   config.version,
        appType:      Capacitor.getPlatform(),
        plugins:      [new BugsnagPluginReact()],
        onError:      function (event) {
            event.addMetadata('debug', '_errors', event.errors);

            if (event.device.userAgent?.toLowerCase().includes('phantomjs')) {
                return false;
            }
            if (document.location.host.includes('.translate.goog')) {
                return false;
            }
        },
    })
    BugsnagPerformance.start({apiKey: config.bugsnagApiKey})
}

L.Marker.prototype.options.icon = L.icon({
    iconSize:      [25, 41],
    shadowSize:    [41, 41],
    iconAnchor:    [13, 41],
    iconUrl:       icon,
    iconRetinaUrl: icon2x,
    shadowUrl:     iconShadow
});

const router = createRouter({routeTree, trailingSlash: 'preserve'})

if (config.clarityProjectId) {
    Clarity.init(config.clarityProjectId);
}

// noinspection SpellCheckingInspection
const firebaseConfig = (
    config.firebase_project === 'scorepal-co'
        ? {
            apiKey:            "AIzaSyD3BwzqmvdMhK0jFVhnaCAC5zRGMhfoCXY",
            authDomain:        "scorepal-co.firebaseapp.com",
            projectId:         "scorepal-co",
            storageBucket:     "scorepal-co.firebasestorage.app",
            messagingSenderId: "807792745504",
            appId:             "1:807792745504:web:5fc95be76db60c47e03045",
            measurementId:     "G-H18SDMTRK9"
        }
        : {
            apiKey:            "AIzaSyA8PkeXtl20u69PlucDkL7hsCCEeseZk9A",
            authDomain:        "padel-b6d32.firebaseapp.com",
            projectId:         "padel-b6d32",
            storageBucket:     "padel-b6d32.firebasestorage.app",
            messagingSenderId: "952547126456",
            appId:             "1:952547126456:web:87003bfd0d91113dba984d",
            measurementId:     "G-QW2X2HP59S"
        }
);
// if (process.env.NODE_ENV === 'production') {
//     import('firebase/analytics')
//         .then(({getAnalytics}) => {
//             getAnalytics(firebaseApp)
//         })
//         .catch((err) => {
//             console.log('Analytics not loaded', err)
//         })
// }

initializeApp(firebaseConfig);

function renderReactDom() {
    const rootElement = document.getElementById('root')!

    if (!rootElement.innerHTML) {
        const root = ReactDOM.createRoot(rootElement)
        root.render(
            <StrictMode>
                <RouterProvider router={router} />
            </StrictMode>
        )
    }
}

if (Capacitor.getPlatform() === 'web') {
    renderReactDom();
} else {
    document.addEventListener('deviceready', () => {

        SafeArea.enable({
            config: {
                customColorsForSystemBars: true,
                statusBarColor:            '#25252580', // transparent
                statusBarContent:          'dark',
                navigationBarColor:        '#25252580', // transparent
                navigationBarContent:      'dark',
            },
        });

        renderReactDom();
    }, false);
}
